import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'

const MetaPixel = () => {
  const location = useLocation()
  const pixelInitialized = useRef(false)
  useEffect(() => {
    if(pixelInitialized.current && !window.fbqInitialized) {
      (function(f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function(...args: any[]) {
          n.callMethod ?
            n.callMethod(...Array.from(args)) :
            n.queue.push(...Array.from(args))
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = v
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      pixelInitialized.current = true
      window.fbqInitialized = true
      window.fbq('init', '754761450605500')
    }
    if(window?.fbq) {
      window.fbq('track', 'PageView')
    }
  }, [ location ])

  return (
    <Helmet>
      <script>
        {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '754761450605500');
          `}
      </script>
      <noscript>
        {`<img
          height="1"
          width="1"
          style={{display: 'none'}}
          src="https://www.facebook.com/tr?id=754761450605500&ev=PageView&noscript=1"
        />`}
      </noscript>
    </Helmet>
  )
}

export default MetaPixel
